// @flow
import { combineReducers } from 'redux';

import Auth from './auth/reducers';
import Layout from './layout/reducers';
import { animationReducer } from './animation';
export default (combineReducers({
    Auth,
    Layout,
    animation: animationReducer,
}));
